import React, { Component } from 'react'
import { connect } from 'react-redux'
import store from '../../engine/store'
import PhoneInput from 'react-phone-input-2'
import 'react-phone-input-2/lib/style.css'
import parsePhoneNumber from 'libphonenumber-js'

import { InfoBulle } from '../ImportAll'
import './Bloc.css'

class BlocPhoneNumber extends Component {
    render() {
        /////////////////////////////////
        // définition du style du bloc //
        /////////////////////////////////
        let className = 'Bloc fade-in bloc-full'
        const style = {}
        style.display = 'table'
        style.minHeight = '122px'

        //////////////////////////////////
        // définition de l'état du bloc //
        //////////////////////////////////
        let infobulle
        if (this.props.infobulle && this.props.infobulle !== undefined) {
            infobulle = (
                <div className="infoBulleContainer">
                    <InfoBulle text={this.props.infobulle} />
                </div>
            )
        }

        let erreur = <div></div>
        if (this.props.validated === false) {
            if (this.props.messageErreur) {
                erreur = (
                    <div className="erreurTextFormat">
                        {this.props.messageErreur}
                    </div>
                )
            }
        }

        let premadeContent = (
            <div>
                <div className="labelfield">{this.props.label}</div>
                <div className="container-tel-form">
                    <PhoneInput
                        country={'fr'}
                        value={this.props.targetDataValue}
                        enableSearch={true}
                        placeholder={this.props.placeholder}
                        countryCodeEditable={false}
                        enableTerritories={true}
                        onlyCountries={[
                            'fr', // FRANCE METROPOLITAINE
                            'gp', // GUADELOUPE -
                            'mq', // MARTINIQUE -
                            're', // REUNION -
                            'mf', // ST MARTIN FR -
                            'gf', // GUYANE -
                            'yt', // MAYOTTE --> non fonctionnel mayotte utilise le même indicatif que la réunion.
                            'nc', // NOUVELLE CALÉDONIE -
                            'pf', // POLYNÉSIE FRANÇAISE -
                            'pm', // ST PIERRE ET MIQUELON -
                            'wf', // WALLIS & FUTUNA -
                            'bl', // saint bathélemy -
                            'be',
                            'de',
                            'it',
                            'es',
                            'lu',
                            'ch',
                        ]}
                        onChange={(phone) =>
                            store.dispatch({
                                type: 'SET',
                                value: {
                                    key: this.props.linked_data_id,
                                    value: '+' + phone,
                                },
                            })
                        }
                        isValid={(value, country) => {
                            let valid = false
                            const phoneNumber = parsePhoneNumber(
                                value,
                                country.iso2.toUpperCase()
                            )

                            if (phoneNumber) {
                                valid = phoneNumber.isValid()
                            }
                            store.dispatch({
                                type: 'SET',
                                value: {
                                    key:
                                        this.props.linked_data_id +
                                        '_validated',
                                    value: valid,
                                },
                            })
                            return valid
                        }}
                    />
                </div>
                {erreur}
            </div>
        )

        return (
            <div>
                <div className={className} style={style}>
                    {infobulle}
                    {premadeContent}
                </div>
            </div>
        )
    }
}

const mapStateToProps = (state, ownProps) => {
    return {
        targetDataValue: state.answer[ownProps.linked_data_id],
        validated: state.answer[ownProps.linked_data_id + '_validated'],
    }
}

export default connect(mapStateToProps)(BlocPhoneNumber)
